export class HttpStatusCodes {
  static badRequest = 400;
  static internalServerError = 500;
  static unauthorized = 401;
  static forbidden = 403;
  static notFound = 404;
  static payloadTooLarge = 413;
  static tooManyRequest = 429;
  static unprocessableEntity = 422;
}
